/**
 * Created by zhaoxu on 2018/9/21.
 */
export default {
  openNewWindow: function (url) {
    window.open(url);
  },
  redirect2QxLogin: function () {
    window.location.href = process.env.VUE_APP_SSP_URL + '/login';
  },
}